import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const stripWww = (h) => h.replace(/^www\./, "");
const sameSite = (() => {
  try {
    return stripWww(new URL(BACKEND_URL).hostname) === stripWww(window.location.hostname);
  } catch { return false; }
})();
const API_BASE = sameSite ? window.location.origin : BACKEND_URL;

export const api = axios.create({
  baseURL: `${API_BASE}/api`,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Une erreur est survenue. Veuillez réessayer.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const IMAGES = {
  logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_ac65b6e9-0be9-43f3-89c4-b6217a5e20ef/artifacts/e88pf2gy_ITALIAN%20CLUB%20%282%29.webp",
  terrace1: "https://customer-assets-m6fa6gv7.emergentagent.net/job_ac65b6e9-0be9-43f3-89c4-b6217a5e20ef/artifacts/a64agplm_ChatGPT%20Image%207%20ago%202026%2C%2019_23_27.png",
  terrace2: "https://customer-assets-m6fa6gv7.emergentagent.net/job_ac65b6e9-0be9-43f3-89c4-b6217a5e20ef/artifacts/43lwn5no_ChatGPT%20Image%207%20ago%202026%2C%2019_22_32.png",
  pasta: "https://images.unsplash.com/photo-1516100882582-96c3a05fe590?crop=entropy&cs=srgb&fm=jpg&q=85",
  pasta2: "https://images.unsplash.com/photo-1498579150354-977475b7ea0b?crop=entropy&cs=srgb&fm=jpg&q=85",
  music: "https://images.unsplash.com/photo-1530189873666-a792be008b5b?crop=entropy&cs=srgb&fm=jpg&q=85",
  cocktail: "https://images.unsplash.com/photo-1774806270948-4edf892c20b7?crop=entropy&cs=srgb&fm=jpg&q=85",
  award2026: "https://customer-assets-v7afamib.emergentagent.net/job_club-italia/artifacts/yc6lu291_RestaurantGuru_Certificate1%20%281%29.webp",
};

export const CATEGORIES = ["Entrées", "Entrées à partager", "Pâtes", "Plats", "Pizzeria", "Desserts", "Apéritifs", "Cocktails", "Virgin Cocktails", "Bières Pression", "Bières Bouteille", "Boissons Fraîches", "Caféterie", "Digestifs", "Whisky", "Rhum", "Vins Rouges", "Sélection de Prestige", "Vins Blancs", "Vins Rosés", "Les Bulles"];

export const EVENT_TYPES = ["Live music", "Piano voix", "Karaoké", "Soirée football", "Soirée privée", "Concert", "Groupe", "DJ / animation"];

export const STATUS_LABELS = {
  en_attente: "En attente",
  confirmee: "Confirmée",
  refusee: "Refusée",
  annulee: "Annulée",
  publie: "Publié",
  brouillon: "Brouillon",
  annule: "Annulé",
  complet: "Complet",
};
